module.exports = __webpack_public_path__ + "static/media/girl.c0b19974.jpeg";